import { Schema } from "@ext/markdown/core/render/logic/Markdoc";

export const em: Schema = {
	render: "em",
};
